import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { ClientsImportNotificatorBase } from '@skylab-shared/business';
import { EventNotificationsService } from '../event-notifications.service';

@Injectable({ providedIn: 'root'})
@Wrapper(ClientsImportNotificatorBase)
export class ClientsImportNotificator {
    public constructor(
        eventNortifications: EventNotificationsService,
        http: Http
    ) { }
}
